const createCssPositionString = (x, y) => `${x}% ${y}%`;

export default createCssPositionString;
